import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DType, SelectOption } from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import { DialogsService } from '../dialogs.service';
import { LocalizeService } from '../../core/pipes/localize.service';
import { HttpService } from '../../core/http/http.service';
import { PipesModule } from '../../core/pipes/pipes.module';
import { DTypeModule } from '../../core/dtype/dtype.module';
import { NextServicio, ServiceWorkplaceUserAssignment } from '../../modules/admin/services/services.types';
import { NextTaskTypeForm } from '../../core/task-type/task-type.types';
import { DTypeService } from '../../core/dtype/dtype.service';
import { NextMethodsEnum } from '../../core/enums/next-methods.enum';

@Component({
    selector: 'app-workplace-user-assignment-dialog',
    templateUrl: './workplace-user-assignment-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
        .workplace-user-assignment-dialog-panel {

            .mat-mdc-dialog-container {
        
                .mat-mdc-dialog-surface {
                    padding: 0 !important;
                }
            }
        }
        `
    ],
    imports: [DTypeModule, MatButtonModule, MatIconModule, TranslocoModule, PipesModule, MatTooltipModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkplaceUserAssignmentDialogComponent {

    public data: {
        dtype: Signal<DType>,
        user: ServiceWorkplaceUserAssignment,
        service: NextServicio
    } = inject(MAT_DIALOG_DATA);
    dtypeForm = computed(() => {
        const dtype = this.data.dtype();
        return this.dtypeService.getDtypeFormFromDtype(dtype, { ...this.data.user }, { readonly: true });
    });
    item: NextTaskTypeForm;
    options: string[] = [];

    workdayOptions: SelectOption[] = [];

    private dialogRef = inject(MatDialogRef<WorkplaceUserAssignmentDialogComponent>);
    private dtypeService = inject(DTypeService);
    private dialogsService = inject(DialogsService);
    private translocoService = inject(TranslocoService);
    private localize = inject(LocalizeService);
    private httpService = inject(HttpService);
    private snackbar = inject(MatSnackBar);

    async openUserQrDialog(assignment: ServiceWorkplaceUserAssignment) {
        const dialog = this.dialogsService.openUserQrDialog(assignment);
    }

    async regeneratePassword() {
        const confirm = await this.dialogsService.openConfirmDialog(this.translocoService.translate('warning'), this.translocoService.translate('generateAndSendNewPasswordWarning'));
        if (confirm) {
            try {
                const reply = await firstValueFrom(this.httpService.post(NextMethodsEnum.regeneratePassword, {userId: this.data.user.userId, serviceId: this.data.service.serviceId}));
                if (reply.status < 400) {
                    this.snackbar.open(this.translocoService.translate('newPasswordSentToMissionUser') + ": " + this.data.user.userName, this.translocoService.translate('accept'), { duration: 5000 });
                }
            } catch (error) {
                console.error(error);
                this.dialogsService.openErrorDialog({
                    message: error?.echo && Object.keys(error.echo).length ? this.localize.transform(error.echo) : undefined
                });
            }
        }
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
